import React from "react";
import BreadCrumb from "../Components/BreadCrumb";
import { Table } from "react-bootstrap";
import { useGetVacancyDownloadQuery } from "../../../redux/services/internal/apiHome";
import Spinner from "../Components/Spinner";

const FooterTopCategory = ({ benchId, apicategory, pageTitle }) => {
  const {
    data: vacancydata,
    isLoading,
    isError,
  } = useGetVacancyDownloadQuery({ benchId, apicategory });

  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    return <div>Error fetching gallery data!</div>;
  }

  return (
    <>
      <div className="col-12 col-sm-12 col-md-9 col-lg-9">
        <BreadCrumb title={pageTitle} />
        <div className="chairman-detail my-4">
          <div className="container">
            <div className="table-responsive">
              <Table striped bordered hover className="custom-table">
                <thead>
                  <tr>
                    <th>Sr.No.</th>
                    <th>Title</th>
                    <th>Date</th>
                    <th>Documents</th>
                  </tr>
                </thead>
                <tbody>
                  {vacancydata?.status && vacancydata.data?.length > 0 ? (
                    vacancydata.data.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.title}</td>
                        <td>{item.created_at}</td>
                        <td className="text-center">
                          {item.upload_image_path ? (
                            <a
                              target="_blank"
                              href={item.upload_image_path}
                              rel="noopener noreferrer"
                            >
                              <i className="fas fa-file-pdf"></i>
                            </a>
                          ) : (
                            "No Document"
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4">No Record Found</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FooterTopCategory;
